import { render, staticRenderFns } from "./sortItem.vue?vue&type=template&id=a75d2af2&scoped=true&"
import script from "./sortItem.vue?vue&type=script&lang=js&"
export * from "./sortItem.vue?vue&type=script&lang=js&"
import style0 from "./sortItem.vue?vue&type=style&index=0&id=a75d2af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75d2af2",
  null
  
)

export default component.exports